module.exports = __webpack_public_path__ + "img/Marketing target Icon - charcoal.435668c6.svg";